export const MATCH_DATA_ALIGNMENT = [
  {
    title: 'Skills',
    key: 'skills',
    dash: '----------',

  },
  {
    title: 'Education',
    dash: '------',
    key: 'education',
  },
  {
    title: 'Work History',
    dash: '----',
    key: 'work_history',
  },
]

 export const CATEGORY_ICON_MAP: Record<string, string> = {
    very_high: '/assets/icons/results/match-scores/h1_plus.svg',
    high: '/assets/icons/results/match-scores/h1.svg',
    medium: '/assets/icons/results/match-scores/med.svg',
    low: '/assets/icons/results/match-scores/low.svg'
  };

export const CATEGORY_LABEL_MAP: Record<string, string> = {
  very_high: 'HI+',
  high: 'HI',
  medium: 'MED',
  low: 'LO'
};

export const CATEGORY_ICON_MAP_DETAIL: Record<string, string> = {
  very_high: '/assets/icons/summary/h1_plus_circle.svg',
  high: '/assets/icons/summary/h1_circle.svg',
  medium: '/assets/icons/summary/med_circle.svg',
  low: '/assets/icons/summary/lo_circle.svg'
};

export const EDUCATION_LEVELS: { key: string; label: string }[] = [
  {
    key: 'HIGH_SCHOOL',
    label: 'Pursuing degree'
  },
  {
    key: 'BACHELORS',
    label: "Bachelor's"
  },
  {
    key: 'MASTERS',
    label: "Master's"
  },
  {
    key: 'DOCTORATE',
    label: 'Doctorate'
  }
];